module.exports = __webpack_public_path__ + "static/img/03.5281e64.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour6/03.jpg
// module id = jxIz
// module chunks = 0